import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import DocsSidebar from './DocsSidebar';
import { DocsProvider } from './components/DocsCtx';
import AuthBanner from './components/AuthBanner';

// Flat list of all nav items for the mobile horizontal tab bar.
// Mirrors DocsSidebar sections. Per-endpoint pages were retired in favour of
// the live Scalar reference; conceptual deep-dives live as anchored sections
// inside Getting Started.
const mobileNavItems = [
  { label: 'Overview', path: 'overview' },
  { label: 'Authentication', path: 'authentication' },
  { label: 'Try It', path: 'try-it' },
  { label: 'Getting Started', path: 'getting-started' },
  { label: 'Outreach API', path: 'getting-started#outreach' },
  { label: 'Reply Behaviour', path: 'getting-started#reply-behaviour' },
  { label: 'Flows API', path: 'getting-started#flows' },
  { label: 'Webhooks', path: 'getting-started#webhooks' },
  { label: 'API Reference', path: 'swagger' },
];

const IntegrationDocs = () => {
  const location = useLocation();

  return (
    <DocsProvider>
      <div className="flex flex-col md:flex-row h-full overflow-hidden">
        {/* Mobile: horizontal scrollable nav */}
        <nav className="md:hidden overflow-x-auto bg-gray-900 px-3 py-2 flex gap-1 flex-shrink-0">
          <Link
            to="/"
            className="px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap flex-shrink-0 bg-slate-600 text-white hover:bg-slate-500"
          >
            &larr; App
          </Link>
          {mobileNavItems.map((item) => {
            const isActive = location.pathname.includes(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap flex-shrink-0 ${
                  isActive
                    ? 'bg-sky-500 text-white'
                    : 'bg-gray-700 text-gray-200 hover:bg-gray-600'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        {/* Desktop: vertical sidebar */}
        <div className="hidden md:block w-[260px] flex-shrink-0 overflow-y-auto bg-[#0f172a]">
          <DocsSidebar />
        </div>

        {/* Content area */}
        <div className="flex-1 overflow-y-auto">
          <div className="px-4 md:px-6 pt-4">
            <AuthBanner />
          </div>
          <div className="p-4 md:p-6">
            <Outlet />
          </div>
        </div>
      </div>
    </DocsProvider>
  );
};

export default IntegrationDocs;
